import clsx from "clsx";
import React from "react";
import { FormColumnSharedProps } from "./FormColumnTypes";

const FormColumn2Wide: React.FC<FormColumnSharedProps> = ({ children, className = "" }) => (
  <div className={clsx("col-lg-6 col-md-12 col-sm-12", className)}>{children}</div>
);

export default FormColumn2Wide;
